import React from 'react';
import BankImportPage from './BankImportPage';

export default function RevolutPage() {
  return (
    <BankImportPage
      title="Revolut Import"
      description="Upload a Revolut CSV file and view the Revolut register in one place."
      fieldLabels={['Date', 'Description', 'Amount', 'Balance']}
      listEndpoint="/api/revolut"
      importEndpoint="/api/revolut/import"
      bankId="REVOLUT"
      emptyText="No Revolut records found."
      exchangeRate={{
        settingKey: 'revolut_exchange_rate',
        label: '1 CHF = ? EUR',
        defaultValue: '1'
      }}
    />
  );
}
